import Modal from "@/component/CustomModal";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import InputWithClear from "@/component/InputWithClear";
import { recordTitleMaxLen } from "@/constants/record";

interface MobileInputModalProps {
  title?: string;
  type?: string;
  limitPattern?: RegExp;
  updateValue: (newValue: string) => Promise<void>;
}

export interface MobileInputModalRef {
  open: (value: string) => void;
  close: () => void;
}

const MobileInputModal = forwardRef<MobileInputModalRef, MobileInputModalProps>(
  (props, ref) => {
    const { title, type, limitPattern, updateValue } = props;
    const [newSpeakerName, setNewSpeakerName] = useState("");
    const [visible, setVisible] = useState(false);
    const initialValue = useRef("");

    const onClose = () => {
      setVisible(false);
    };

    const onSpeakerNameInput = (inputValue: string) => {
      setNewSpeakerName(inputValue);
    };

    const handleSave = async () => {
      try {
        if (!newSpeakerName?.trim()) return;
        if (newSpeakerName.trim() === initialValue.current) {
          setVisible(false);
          return;
        }
        await updateValue(newSpeakerName.trim());
        setVisible(false);
      } catch (error) {
        console.error("保存失败", error);
      }
    };

    useImperativeHandle(ref, () => ({
      open: (value: string) => {
        setVisible(true);
        setNewSpeakerName(value);
        initialValue.current = value;
      },
      close: onClose,
    }));

    return (
      <Modal visible={visible} mask>
        <div className="bg-white w-80 h-49.25 rounded-4 relative overflow-hidden">
          <div className="text-#333333 font-500 text-4.5 lh-4.5 pt-8 pb-4 text-center">{title || '重命名'}</div>
          <InputWithClear
            className="w-68 h-12.5 rounded-3 px-4 border-0 bg-#F4F6F9 text-size-3.75 focus:outline-none relative"
            wapperClassName="flex justify-center"
            limitPattern={limitPattern}
            value={newSpeakerName}
            maxLength={recordTitleMaxLen}
            onMyChange={onSpeakerNameInput}
            type={type}
            autoFocus
          />
          <div className="mt-7 h-13 lh-13 text-center w-full flex items-center b-t-1px b-t-solid b-#000/10 text-4">
            <div
              className="h-full flex-1 b-r-1px b-r-solid b-#000/10 text-#000000"
              onClick={onClose}
            >
              取消
            </div>
            <div className={`h-full  flex-1 text-#487FF8 ${!newSpeakerName?.trim() && 'opacity-70'}`} onClick={handleSave}>
              确定
            </div>
          </div>
        </div>
      </Modal>
    );
  }
);

export default MobileInputModal;
